export enum TreeViewSelectable {
  single = 'single',
  multi = 'multi',
  off = 'off',
}
